import { gql } from '@apollo/client'

const updateVirtualAssetFile = gql(`
    mutation updateVirtualAssetFile($input: UpdateAssetFileInput,$project: String,  $module: String) {
        updateVirtualAssetFile(
            input:$input, 
            project: $project
            module: $module
        ) {
            id
            fileId
            assetId
            mediaId
            # tags
            fileName
            fileSize
            url
            name
            createdAt
            createdBy
            updatedAt
            isArchived
            category{
                id
            }
        }
    }`
)

export default updateVirtualAssetFile
